import { ApolloClient, InMemoryCache, QueryOptions } from '@apollo/client'
import { vaultSubgraphEndpoint, dropVaultSubgraphEndpoint } from '~/constants/marketplace'

const baseFactory = new ApolloClient({
  uri: vaultSubgraphEndpoint,
  cache: new InMemoryCache(),
})

const dropFactory = new ApolloClient({
  uri: dropVaultSubgraphEndpoint,
  cache: new InMemoryCache(),
})

export interface VaultCreatedEvent {
  creator: string
  nftAddress: string
  nftId: string
  vaultAddress: string
  fragments: number
  royaltyBps: number
  isDrop: boolean
}

export const subgraphQuery = async (options: QueryOptions): Promise<VaultCreatedEvent[]> => {
  const baseResult = await baseFactory.query(options)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const events: VaultCreatedEvent[] = baseResult.data.fragmentsVaultCreateds.map((event: any) => {
    return {
      creator: event.creator,
      nftAddress: event.nftAddress,
      nftId: event.nftId,
      vaultAddress: event.vaultAddress,
      fragments: Number(event.fragments),
      royaltyBps: Number(event.royaltyBps),
      isDrop: false,
    }
  })

  const dropResult = await dropFactory.query(options)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return events.concat(dropResult.data.fragmentsVaultCreateds.map((event: any) => {
    return {
      creator: event.creator,
      nftAddress: event.nftAddress,
      nftId: event.nftId,
      vaultAddress: event.vaultAddress,
      fragments: Number(event.fragments),
      royaltyBps: Number(event.royaltyBps),
      isDrop: true,
    }
  }))
}
